export default {
    bank: {list: []}
}
